import React from 'react'
import PropTypes from 'prop-types'

import Card from '..'
import {
  Icon, Subtitle, Title, Container
} from './styles'

const NotLoanCard = ({ title, subtitle }) => (
  <Card
    style={{
      boxShadow: 'none',
      marginTop: '5px',
      width: '100%',
      padding: '0px',
      display: 'flex',
      borderRadius: '0 0 12px 12px',
    }}
  >
    <Container>
      <Icon>
        <span className="material-symbols-outlined" style={{ fontSize: 35 }}>
          home_repair_service
        </span>
      </Icon>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Container>
  </Card>
)

NotLoanCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
}

export default NotLoanCard
